import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import type { FiatPrice } from "@b2bportal/ground-api";
import { FilterPrice as FilterPriceUI } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FilterPrice.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent, type PriceRange } from "~core-cars/types";

export type FilterPriceProps = {
  onChange: (values: PriceRange) => void;
  range?: {
    min: FiatPrice;
    max: FiatPrice;
  };
  selectedRange: PriceRange;
  label: string;
} & PlatformComponentProps;

const COMPONENT_KEY = CoreCarsComponent.FilterPrice;

export const FilterPrice = ({
  onChange,
  selectedRange,
  range,
  label,
  className,
}: FilterPriceProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <FilterPriceUI
      className={clsx(block, className)}
      minimumPrice={range?.min}
      maximumPrice={range?.max}
      isMinValueConfigurable={true}
      initialValue={{
        minPrice: selectedRange.min,
        maxPrice: selectedRange.max,
      }}
      onFilterPriceChange={({ minPrice, maxPrice }) =>
        onChange({ min: minPrice, max: maxPrice })
      }
      label={label}
    />
  );
};
